<h2 class="auth-header">Zaloguj się</h2>

<div class="auth-alert auth-alert--info" *ngIf="sendPassword">
  Nowe hasło zostało wysłane na adres e-mail i sms-em.
</div>

<div class="auth-alert auth-alert--warning" *ngIf="error">
  {{ error }}
</div>

<table style="width: 100%">
  <tr>
    <td>
      <button style="width: 100%" mat-flat-button color="primary" type="button" class="d-block w-100 text-center" (click)="lorealLogin()">Domena @loreal</button>
    </td>
    <td>
      <button style="width: 100%" mat-flat-button color="primary" type="button" class="d-block w-100 text-center" (click)="open = 'team'">Inna domena</button>
    </td>
  </tr>
</table>

<form [formGroup]="loginForm" (ngSubmit)="onSubmit()" *ngIf="open === 'team'">


  <mat-form-field class="full-width-field">
    <input matInput type="email" placeholder="Email" formControlName="login" [errorStateMatcher]="matcher">
    <!-- <mat-hint>Errors appear instantly!</mat-hint> -->
    <mat-error *ngIf="loginForm.controls['login'].hasError('email') && !loginForm.controls['login'].hasError('required')">
      Wpisz poprawny adres e-mail
    </mat-error>
    <mat-error *ngIf="loginForm.controls['login'].hasError('required')">
      Adres e-mail jest <strong>wymagany</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field class="full-width-field">
    <input style="margin-right: 30px; width: calc(100% - 30px);" matInput [type]="showPassword ? 'text' : 'password'" placeholder="Hasło" formControlName="password" [errorStateMatcher]="matcher">
    <button type="button" class="passwordShowHide" (click)="showPassword = !showPassword">
      <i class="fas {{ !showPassword ? 'fa-eye' : 'fa-eye-slash' }}"></i>
    </button>
    <mat-error *ngIf="loginForm.controls['password'].hasError('required')">
      Hasło jest <strong>wymagane</strong>
    </mat-error>
  </mat-form-field>

  <div class="alert alert-danger" *ngIf="codeTimeout">
    Czas na pisanie kodu SMS wygasł. Zaloguj się ponownie.
  </div>

  <mat-form-field class="full-width-field" *ngIf="showSMSCode">
    <input matInput placeholder="Kod SMS" formControlName="code" [errorStateMatcher]="matcher">
    <mat-error *ngIf="loginForm.controls['code'].hasError('required')">
      Kod dostępu jest <strong>wymagany</strong>
    </mat-error>
  </mat-form-field>
  <br>
  <div class="text-center">
    <button mat-stroked-button type="submit" [disabled]="disabledSubmit">Zaloguj się</button>
    <br>
    <a class="btn--small" mat-button routerLink="/auth/reset-password">Przypomnij hasło</a>
  </div>
</form>


